"use client";

import type { ReactNode } from "react";
import { fraunces, spaceMono } from "@/lib/fonts";

type OnboardingLayoutProps = {
  currentStep: number;
  totalSteps: number;
  children: ReactNode;
  /** When set, shows a Skip control that calls this (e.g. jump to final screen). */
  onSkip?: () => void;
};

export function OnboardingLayout({
  currentStep,
  totalSteps,
  children,
  onSkip,
}: OnboardingLayoutProps) {
  return (
    <div
      className={`joydrop-onboarding relative flex min-h-screen flex-col bg-background ${fraunces.variable} ${spaceMono.variable}`}
    >
      <div
        className="joydrop-onboarding__grain"
        aria-hidden
      />
      <div className="mx-auto flex w-full max-w-[420px] flex-1 flex-col px-6">
        <div className="flex items-start justify-between gap-4 pt-8 pb-2">
          <div className="font-display text-lg font-black tracking-tight text-foreground [font-variation-settings:'opsz'_72,'wght'_900]">
            joydrop
          </div>
          {onSkip ? (
            <button
              type="button"
              onClick={onSkip}
              className="shrink-0 pt-0.5 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-200 hover:text-foreground"
            >
              Skip
            </button>
          ) : null}
        </div>
        <div className="flex items-center gap-1.5 pt-2 pb-6">
          {Array.from({ length: totalSteps }, (_, i) => {
            const isActive = i === currentStep;
            const isPast = i < currentStep;
            return (
              <div
                key={i}
                className={`rounded-full transition-all duration-500 ease-out ${
                  isActive
                    ? "h-2 w-6 bg-accent"
                    : isPast
                      ? "h-1.5 w-1.5 bg-foreground/40"
                      : "h-1.5 w-1.5 bg-foreground/15"
                }`}
              />
            );
          })}
        </div>
        <div className="flex flex-1 flex-col pb-10 animate-fade-in-up">
          {children}
        </div>
      </div>
    </div>
  );
}
